module.exports = __webpack_public_path__ + "img/beer_id-73.db07aabb.png";